import { create } from "zustand";

interface ChangeSelectedCompanyStore {
  isChangeSelectedCompany: boolean;
  setIsChangeSelectedCompany: (isChange: boolean) => void;
}

export const useChangeSelectedCompanyStore =
  create<ChangeSelectedCompanyStore>()((set) => ({
    isChangeSelectedCompany: false,
    setIsChangeSelectedCompany: (isChange) =>
      set({ isChangeSelectedCompany: isChange })
  }));
